var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('com-form',{ref:"form",attrs:{"label-width":"120px","col":2,"configs":_vm.formConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }